import BScroll from "@better-scroll/core";
import React, { useLayoutEffect, useMemo, useRef } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

interface ProgressListType {
  /**
   * 状态编码
   */
  statusCode: number;
  /**
   * 节点状态名称
   */
  statusDesc: string;
  /**
   * 节点状态时间
   */
  statusTime: string;
}

interface PropsType {
  /**
   * 进度顺序列表
   */
  progressList: ProgressListType[];
  /**
   * 当前进度状态
   */
  currentStatus: number;
}

/**
 * 顶部进度栏
 * @param props
 * @returns
 */
const Progress = (props: PropsType) => {
  const { progressList = [], currentStatus } = props;
  const itemContainer = useRef(null);

  // 当前进度状态在进度列表中的索引
  const currentIndex = useMemo(() => {
    const index =
      progressList?.findIndex(
        (item) => String(item?.statusCode) === String(currentStatus)
      ) ?? 0;
    return index;
  }, [progressList, currentStatus]);

  // 进度栏滚动效果
  useLayoutEffect(() => {
    if (!Array.isArray(progressList) || progressList.length === 0) return;
    let startX = 0;
    const progressItem = document.getElementById("progressItem0");
    const itemWidth = progressItem?.offsetWidth || 120;
    // 没有找对应的或前两个不用移动
    if (currentIndex === -1 || currentIndex === 0 || currentIndex === 1) {
      startX = 0;
    } else {
      startX = -(currentIndex - 1) * itemWidth;
    }
    const _BScroll = new BScroll(itemContainer.current!, {
      scrollX: true,
      startX: startX,
      eventPassthrough: "vertical",
      bounce: false,
    });
    return () => {
      if (!!_BScroll) _BScroll.destroy();
    };
  }, [currentIndex, progressList, currentStatus]);

  return Array.isArray(progressList) && !!progressList.length ? (
    <div className={styles.progressCompWrapper}>
      <div className={styles.itemContainer} ref={itemContainer}>
        <div className={styles.itemList}>
          <div id="progress">
            {progressList.map((item, index) => {
              const isDoneItem = index <= currentIndex;
              return (
                <div
                  id={"progressItem" + index}
                  className={styles.progressItem}
                  key={item?.statusCode}
                >
                  <div className={styles.iconWrapper}>
                    {index !== 0 && (
                      <div className={styles.lineWrapper}>
                        <div
                          className={classNames(
                            styles.line,
                            isDoneItem && styles.blackLine
                          )}
                        ></div>
                      </div>
                    )}
                    <div
                      className={
                        isDoneItem ? styles.blackCircle : styles.lineCircle
                      }
                    >
                      {currentIndex === index ? "✓" : index + 1}
                    </div>
                  </div>
                  <div className={styles.progressName}>{item.statusDesc}</div>
                  {isDoneItem && (
                    <div className={styles.progressDate}>{item.statusTime}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Progress;
